import { render, staticRenderFns } from "./SubscriptionRequests.vue?vue&type=template&id=b1c51258&"
import script from "./SubscriptionRequests.vue?vue&type=script&lang=js&"
export * from "./SubscriptionRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3289102252/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b1c51258')) {
      api.createRecord('b1c51258', component.options)
    } else {
      api.reload('b1c51258', component.options)
    }
    module.hot.accept("./SubscriptionRequests.vue?vue&type=template&id=b1c51258&", function () {
      api.rerender('b1c51258', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/welcome/actionItems/SubscriptionRequests.vue"
export default component.exports